import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, Select, MenuItem, InputLabel, FormControl } from '@mui/material';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddTicket({ open, onClose, setOpen }: ModalProps) {
    return (
        <Modal
            className="modal addReply_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Ticket</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" action="">
                        {/* Subject Field */}
                        <div className="control_group">
                            <label htmlFor="">Subject</label>
                            <TextField
                                placeholder="Brief description of your issue"
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        {/* Category Dropdown */}
                        <div className="control_group">
                            <label htmlFor="">Category</label>
                            <FormControl fullWidth>
                                <Select defaultValue="Technical Issue">
                                    <MenuItem value="Technical Issue">Technical Issue</MenuItem>
                                    <MenuItem value="Billing Issue">Billing Issue</MenuItem>
                                    <MenuItem value="Account Issue">Account Issue</MenuItem>
                                    <MenuItem value="General Inquiry">General Inquiry</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {/* Priority Dropdown */}
                        <div className="control_group">
                            <label htmlFor="">Priority</label>
                            <FormControl fullWidth>
                                <Select defaultValue="Medium">
                                    <MenuItem value="Low">Low</MenuItem>
                                    <MenuItem value="Medium">Medium</MenuItem>
                                    <MenuItem value="High">High</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {/* Description Field */}
                        <div className="control_group">
                            <label htmlFor="">Description</label>
                            <TextField
                                placeholder="Please provide detailed information about your issue..."
                                fullWidth
                                hiddenLabel
                                multiline
                            />
                        </div>

                        {/* Footer Buttons */}
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit Ticket</Button>
                        </div>

                    </form>
                </div>
            </div>
        </Modal>
    );
}
